<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <template v-for="(opcion, index) in opciones">
        <v-tab :key="index" :to="{ name: opcion.ruta }" exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'licitacion',
          icono: '',
        },
        {
          nombre: 'Participantes',
          ruta: 'licitacionParticipantes',
          icono: '',
        },
        {
          nombre: 'Visita a la Obra',
          ruta: 'licitacionVisitaObra',
          icono: '',
        },
        {
          nombre: 'Junta de Aclaraciones',
          ruta: 'licitacionJuntaAclaraciones',
          icono: '',
        },
        {
          nombre: 'Apertura de Propuestas',
          ruta: 'licitacionAperturaPropuestas',
          icono: '',
        },
        {
          nombre: 'Fallo',
          ruta: 'licitacionFallo',
          icono: '',
        },
        {
          nombre: 'Eventos',
          ruta: 'licitacionEventos',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
